import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Amplify } from "aws-amplify";
import LandingPage from "./pages/LandingPage";
import AdminDashboard from "./pages/AdminDashboard";
import WalletPreview from "./pages/WalletPreview";
import TestLink from "./pages/TestLink";
import WalletTest from "./pages/WalletTest";
import WalletRedirect from "./pages/WalletRedirect";
import WalletDisplay from "./pages/WalletDisplay";
import LiteLinkLanding from "./pages/LiteLinkLanding";
import JoinProgramLanding from "./pages/JoinProgramLanding";
import CampaignList from "./pages/admin/campaigns/CampaignList";
import CampaignCreate from "./pages/admin/campaigns/CampaignCreate";
import CampaignDetail from "./pages/admin/campaigns/CampaignDetail";
import CampaignEdit from "./pages/admin/campaigns/CampaignEdit";
import ApiKeyGate from "./pages/admin/campaigns/ApiKeyGate";
import "./styles/App.css";

// Import Amplify configuration
// In development: fetch from public/, in production: would be bundled
async function configureAmplify() {
  try {
    const response = await fetch('/amplify_outputs.json');
    const outputs = await response.json();
    Amplify.configure(outputs);
  } catch (error) {
    console.error('Failed to load Amplify configuration:', error);
  }
}

configureAmplify();

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          {/* Campaign admin — gated by API key in localStorage */}
          <Route
            path="/admin/campaigns"
            element={<ApiKeyGate><CampaignList /></ApiKeyGate>}
          />
          <Route
            path="/admin/campaigns/new"
            element={<ApiKeyGate><CampaignCreate /></ApiKeyGate>}
          />
          <Route
            path="/admin/campaigns/:id"
            element={<ApiKeyGate><CampaignDetail /></ApiKeyGate>}
          />
          <Route
            path="/admin/campaigns/:id/edit"
            element={<ApiKeyGate><CampaignEdit /></ApiKeyGate>}
          />
          <Route path="/preview/:param1/:param2" element={<WalletPreview />} />
          {/* JIT wallet lite-links (Phase 2, 2026-08-28) — literal "link"
              segment ranks ahead of the /:param1/:param2 catch-all below
              (React Router v6 scores static segments higher regardless of
              declaration order), so this can't be shadowed by it. */}
          <Route path="/link/:token" element={<LiteLinkLanding />} />
          {/* JIT wallet lite-links Phase 4 (2026-08-28) — open/anonymous QR
              enrollment. Same non-collision reasoning: literal "join"
              first segment ranks ahead of the catch-alls below. */}
          <Route path="/join/:merchantId/:templateId" element={<JoinProgramLanding />} />
          <Route path="/test" element={<TestLink />} />
          <Route path="/wallet-test" element={<WalletTest />} />
          {/* Single parameter wallet route for backward compatibility */}
          <Route path="/wallet/:param2" element={<WalletDisplay />} />
          {/* Root-level single keyword route (e.g., /0TTsvVMO) */}
          <Route path="/:keyword" element={<WalletDisplay />} />
          {/* Two parameter wallet route (e.g., /abc/0TTsvVMO) */}
          <Route path="/:param1/:param2" element={<WalletDisplay />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;